<template>
  <div>
    <div
      class="card !border-none !p-1 m-0 !h-[calc(100vh-150px)] overflow-y-auto !bg-transparent"
      style="width: 100%"
      v-loading="loading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <h3 class="text-black-950 !font-normal text-sm 2xl:!text-base !m-0 !pb-4">
        My Apps & Credentials
      </h3>
      <el-form ref="form">
        <div v-if="!isData === true" class="!border !border-page-border rounded-xl !p-3">
          <div>
            <div
              class="alert alert-info flex items-start !gap-1.5 !mt-0 text-[13px] xl:text-sm 2xl:text-base !rounded-lg text-black-950 !font-normal !bg-brand-50 !border-brand-300 !py-1.5"
            >
              <i class="el-icon-info !text-lg !text-brand-500"></i>
              <span class="fs">
                When you generate a new secret key, you still maintain the original secret. The
                maximum number of client secrets is two. A client secret is either in enabled or
                disabled state.
              </span>
            </div>
            <p class="!text-black-600">Get started by clicking Generate Key button.</p>
          </div>
          <div class="card-footer !border-none !bg-transparent flex justify-start !mt-4 !pl-0">
            <el-form-item class="mb-0 !p-0">
              <button
                class="bg-transparent border hover:text-brand-500 hover:!border hover:!border-brand-500 text-black-700 !px-5 !py-1.5 !rounded-md !border-black-500 text-xs 2xl:text-mds !mr-2"
                @click="goToDashboard"
              >
                Cancel
              </button>
              <el-button
                style="background: var(--brand-500) !important"
                class="!text-white !px-5 !py-2.5 !border-brand-500 !rounded-md text-xs 2xl:text-mds"
                type="button"
                @click="generateNewKey"
              >
                Generate Key
              </el-button>
            </el-form-item>
          </div>
        </div>
        <div class="!p-1" v-if="isData === true">
          <p class="text-[13px] xl:text-sm 2xl:text-mds text-black-800 !font-normal !m-0 !mb-1">
            Client ID
          </p>
          <div>
            <el-input v-on:focus="$event.target.select()" ref="myinput" readonly :value="clientid">
              <el-button slot="append" @click="copy" icon="el-icon-document-copy"></el-button>
            </el-input>
          </div>
        </div>
        <div class="!p-1" v-if="isData === true">
          <p class="text-[13px] xl:text-sm 2xl:text-mds text-black-800 !font-normal !m-0 !mb-1">
            Secret Key
          </p>
          <div>
            <el-input
              v-on:focus="$event.target.select()"
              ref="myinputkey"
              readonly
              :value="secretkey"
            >
              <el-button slot="append" @click="copykey" icon="el-icon-document-copy"></el-button>
            </el-input>
          </div>
        </div>

        <el-divider class="m-0 !mt-6" v-if="isData === true"></el-divider>
        <div class="!p-1" v-if="isData === true">
          <el-collapse>
            <el-collapse-item title="Secret Key">
              <div>
                <!-- table -->
                <el-table :data="data" border v-loading="loading" style="overflow-wrap: normal">
                  <el-table-column
                    label="Created at"
                    width="120"
                    prop="created_at"
                    sortable="custom"
                  >
                    <template slot-scope="scope">
                      <template v-if="scope.row.created_at">
                        <span class="d-inline-block pr-2 text-muted">
                          {{ scope.row.created_at | globalDateTimeFormat }}
                        </span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="Client ID" width="190" prop="clientId" sortable="custom">
                    <template slot-scope="scope">
                      <template v-if="scope.row.clientId">
                        <span class="d-inline-block pr-2 text-muted">
                          {{ scope.row.clientId }}
                        </span>
                      </template>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="Secret Key"
                    width="180"
                    prop="clientSecret"
                    sortable="custom"
                  >
                    <template slot-scope="scope">
                      <template v-if="scope.row.clientSecret">
                        <span class="d-inline-block pr-2 text-muted">
                          {{ scope.row.clientSecret }}
                        </span>
                      </template>
                    </template>
                  </el-table-column>

                  <el-table-column label="Status" width="200" prop="isActive" sortable="custom">
                    <template slot-scope="scope">
                      <span v-if="scope && scope.row && scope.row.isActive" class="circle">
                        Enable
                      </span>
                      <span v-else class="circleone">Disable</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  class="custom-pagination fflex items-center justify-center !mt-3"
                  :current-page.sync="currentPage"
                  :page-size="pageSize"
                  layout="prev, pager, next, jumper, sizes, total"
                  :total="total"
                ></el-pagination>
              </div>
              <div class="card-footer !border-none !bg-transparent flex justify-start !mt-4 !pl-0">
                <el-form-item class="mb-0 !p-0">
                  <button
                    class="bg-transparent border hover:text-brand-500 hover:!border hover:!border-brand-500 text-black-700 !px-5 !py-1.5 !rounded-md !border-black-500 text-xs 2xl:text-mds !mr-2"
                    @click="goToDashboard"
                  >
                    Cancel
                  </button>
                  <el-button
                    style="background: var(--brand-500) !important"
                    class="!text-white !px-5 !py-2.5 !border-brand-500 !rounded-md text-xs 2xl:text-mds"
                    type="button"
                    @click="generateNew"
                  >
                    Generate New Key
                  </el-button>
                </el-form-item>
              </div>
            </el-collapse-item>
          </el-collapse>

          <el-divider class="m-0"></el-divider>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'DocumentNotifications',
    data() {
      return {
        total: 0,
        currentPage: 1,
        pageSize: 0,
        filterText: '',
        loading: false,
        data: [],
        isData: false,
      };
    },
    computed: {
      ...mapGetters('settings', [
        'getClientKeys',
        'getGenerateClientKeys',
        'getfetchGenerateClientKeys',
        'getReGenerateClientKeys',
      ]),
    },
    async mounted() {
      this.loading = true;
      this.GetClientKeys();
      this.loading = false;
    },
    methods: {
      async generateNewKey() {
        this.loading = true;
        await this.$store.dispatch('settings/generateClientKeys');
        this.GetClientKeys();
        this.loading = false;
      },
      async generateNew() {
        this.loading = true;
        await this.$store.dispatch('settings/RegenerateClientKeys');
        this.GetClientKeys();
        this.loading = false;
      },

      async GetClientKeys() {
        try {
          this.loading = true;
          await this.$store.dispatch('settings/fetchClientKeys');
          if (this.getClientKeys) {
            this.data = this.getClientKeys.data;
            this.total = this.getClientKeys.data.length || 0;
            if (
              this.getClientKeys &&
              this.getClientKeys.data &&
              this.getClientKeys.data[0] &&
              this.getClientKeys.data[0].isActive
            ) {
              this.isData = true;
              ((this.clientid = this.getClientKeys.data[0].clientId),
                (this.secretkey = this.getClientKeys.data[0].clientSecret));
            }
          } else {
            this.loading = false;
          }
          this.loading = false;
        } catch (err) {
          console.log('GetClientKeys', err);
        }
      },

      copy() {
        this.$refs.myinput.focus();
        document.execCommand('copy');
      },
      copykey() {
        this.$refs.myinputkey.focus();
        document.execCommand('copy');
      },
      goToDashboard() {
        this.$router.push({ path: '/' });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .circle {
    position: relative;
    padding-left: 20px;
    text-transform: capitalize;
    font-size: 14px;

    &::after {
      background: #08ad36;
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      height: 10px;
      width: 10px;
      display: inline-block;
      border-radius: 50%;
    }
  }

  .circleone {
    position: relative;
    padding-left: 20px;
    text-transform: capitalize;
    font-size: 14px;

    &::after {
      background: #f03232;
      content: '';
      position: absolute;
      top: 4px;
      left: 0;
      height: 10px;
      width: 10px;
      display: inline-block;
      border-radius: 50%;
    }
  }
</style>
